


import './loadable-content.component.scss'
import { Loader } from '../';

const LoadableContent = ({isLoading, children}) =>(<div className='loadable-content'>{isLoading ? <div className={'loadable-content__content'}><Loader className={'loadable-content__content__loader'} /></div> : children}</div>);

export default LoadableContent;